import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import type { ReactNode } from "react";

interface HelpHintProps {
  /** Tooltip content — keep it under 2 short sentences. */
  children: ReactNode;
  /** Accessible label for the trigger; falls back to "Más información". */
  label?: string;
}

/**
 * Compact help icon for admin controls. Shows tooltip on hover/focus.
 * Use next to a Label to explain non-obvious settings without crowding the UI.
 */
export function HelpHint({ children, label = "Más información" }: HelpHintProps) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-zinc-400 transition-colors hover:text-zinc-200 focus-visible:text-zinc-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400/40"
          >
            <HelpCircle className="h-3.5 w-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          className="max-w-xs whitespace-normal break-words text-xs leading-snug"
        >
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
